export default function(output, uuid, el) {
  if (L2H[uuid].debug) {
    console.log(`L2H DEBUG[${uuid}]: ${output}`);
  }
}
